<template>
  
<svg xmlns="http://www.w3.org/2000/svg" width="142.682" height="38.814" viewBox="0 0 142.682 38.814">
  <g id="btn_send" transform="translate(-9.853 9.604)">
    <g id="Valider" transform="translate(9.853 -9.604)">
      <rect id="Rectangle_417" data-name="Rectangle 417" width="142.682" height="38.814" rx="19.407" transform="translate(0 0)" fill="#1bad1a"/>
      <text id="Réglé" transform="translate(50.341 25.907)" fill="#fff" font-size="16" font-family="SegoeUI-Bold, Segoe UI" font-weight="700"><tspan x="0" y="0">Réglé</tspan></text>
    </g>
    <path id="android-done" d="M9.748,17.6,5.873,13.718,4.5,15.027l5.248,5.237L20.977,9.043,19.6,7.734Z" transform="translate(107.611 -2.197)" fill="#fdfdfe"/>
  </g>
</svg>

</template>